import defaultProfile, { asyncRoute } from "./default";
import { type ConfigSection, type GameProfile, type Menu, MenuItem, type ProfileCtx } from "./types";

import { faPuzzlePiece } from "@fortawesome/free-solid-svg-icons";
import { usePropertyBuilder } from "../components/views/config/helpers";
import { type UseEternalMods, useEternalMods } from "../components/views/mods/eternal";
import type { EternalMod } from "../graphql";

const createMenu = (): Menu => {
  const defaultMenu = defaultProfile().menu;
  return [
    {
      ...defaultMenu[0],
      items: [...defaultMenu[0].items],
    },
    {
      ...defaultMenu[1],
    },
  ];
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "LeapGameMode", props: { name: "gameMode" } },
  { component: "ConfSection", props: { name: "multiplier" } },
];

function useMods() {
  const { buildProperty } = usePropertyBuilder();
  const installedModIds = buildProperty<Array<number>>("virtual", "mods", []);
  return useEternalMods(installedModIds);
}

export default (_ctx: ProfileCtx): Partial<GameProfile<EternalMod, UseEternalMods>> => ({
  menu: createMenu(),
  configSections,
  useMods,
});
